export class RestResult {

  status?: string;
  message?: string;
  messages?: string[];
  data?: any;
  metaData?: any;
}
